// WATER USE STATUS
export const GET_WATER_USE_STATUSES = '/water_use_status/query';
export const GET_WATER_USE_STATUS = '/water_use_status/';
export const POST_WATER_USE_STATUS = '/water_use_status/';
export const PUT_WATER_USE_STATUS = '/water_use_status/';
export const DELETE_WATER_USE_STATUS = '/water_use_status/';
export const CHECK_WATER_USE_STATUS_EXISTS = '/water_use_status/query';
